// slider-navigation
(function() {
	
	$('#slider-navigation-prev').on('click', function () {
		var sliderTarget  = $('#' + $(this).data('slider')),
			sliderCounter = $('#slider-navigation-counter');

		sliderTarget.slick('slickPrev');
		sliderCounter.find('.current').text(sliderTarget.slick('slickCurrentSlide') + 1);
	});

	$('#slider-navigation-next').on('click', function () {
		var sliderTarget  = $('#' + $(this).data('slider')),
			sliderCounter = $('#slider-navigation-counter');

		sliderTarget.slick('slickNext');
		sliderCounter.find('.current').text(sliderTarget.slick('slickCurrentSlide') + 1);
	});

})();



// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/slider-navigation/slider-navigation.js